import React from "react";
import { Activity, Zap, Gauge, Waves, Sigma, BatteryCharging } from "lucide-react";

function KPI({ label, value, unit, icon: Icon, testid, tone = "default" }) {
  const toneMap = {
    default: "text-white",
    good: "text-emerald-400",
    warn: "text-yellow-400",
    alert: "text-red-400",
    info: "text-blue-400",
  };
  return (
    <div className="panel panel-hover p-4" data-testid={testid}>
      <div className="flex items-center justify-between">
        <div className="label-tech">{label}</div>
        {Icon && <Icon className="w-3.5 h-3.5 text-zinc-500" strokeWidth={1.5} />}
      </div>
      <div className="mt-3 flex items-baseline gap-1.5">
        <span className={`font-mono-tech text-3xl font-medium tracking-tight ${toneMap[tone]}`}>
          {value ?? "—"}
        </span>
        {unit && <span className="label-tech pb-0.5">{unit}</span>}
      </div>
    </div>
  );
}

function fmt(n, d = 2) {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return Number(n).toFixed(d);
}

export default function KPIGrid({ latest }) {
  const kw = latest?.ttl_kw;
  const kva = latest?.ttl_kva;
  const kvar = latest?.ttl_kvar;
  const pf = latest?.Average_pf;
  const freq = latest?.Frequency;
  const kwh = latest?.KWH_total_net;

  const pfTone = pf == null ? "default" : pf >= 0.95 ? "good" : pf >= 0.85 ? "warn" : "alert";
  const freqTone = freq == null ? "default" : Math.abs(freq - 50) <= 0.5 ? "good" : "warn";

  return (
    <section
      className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4"
      data-testid="kpi-grid"
    >
      <KPI label="TOTAL POWER" value={fmt(kw, 2)} unit="kW" icon={Zap} testid="kpi-kw" />
      <KPI label="APPARENT" value={fmt(kva, 2)} unit="kVA" icon={Activity} testid="kpi-kva" />
      <KPI label="REACTIVE" value={fmt(kvar, 2)} unit="kVAR" icon={Waves} testid="kpi-kvar" />
      <KPI label="POWER FACTOR" value={fmt(pf, 3)} unit="" icon={Sigma} testid="kpi-pf" tone={pfTone} />
      <KPI label="FREQUENCY" value={fmt(freq, 2)} unit="Hz" icon={Gauge} testid="kpi-freq" tone={freqTone} />
      <KPI label="NET ENERGY" value={fmt(kwh, 1)} unit="kWh" icon={BatteryCharging} testid="kpi-kwh" />
    </section>
  );
}
